module.exports = __webpack_public_path__ + "assets/img/Nexon-3-Landing-Page-w540.52a0b7f3.webp";